import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserType } from "@/constants";
import { Loader2, Plus } from "lucide-react";

export function RegistrationDetailsPaymentsLoading({
  userType,
}: {
  userType: UserType;
}) {
  const showOps = userType === UserType.OPERATOR;
  const paymentButtons = showOps ? (
    <div className="flex gap-2">
      <Button variant="outline" size="sm" className="min-w-[80px]" disabled>
        <Plus className="h-4 w-4 mr-2" />
        Add Payment...
      </Button>
      <Button variant="outline" size="sm" className="min-w-[80px]" disabled>
        <Plus className="h-4 w-4 mr-2" />
        Add Fee Adjustment...
      </Button>
    </div>
  ) : null;

  return (
    <>
      <Card className="gap-4">
        <CardHeader>
          <CardTitle className="font-semibold text-xl">
            Registration period compliance
          </CardTitle>
        </CardHeader>
        <CardContent className="flex justify-center py-10">
          <Loader2
            className="h-8 w-8 animate-spin text-muted-foreground"
            aria-label="Loading payments summary"
          />
        </CardContent>
      </Card>
      <Card className="gap-4">
        <CardHeader className="flex flex-row items-center justify-between">
          <CardTitle className="font-semibold text-xl">Payments</CardTitle>
          {paymentButtons}
        </CardHeader>
        <CardContent className="flex justify-center py-10">
          <Loader2
            className="h-8 w-8 animate-spin text-muted-foreground"
            aria-label="Loading payments"
          />
        </CardContent>
      </Card>
    </>
  );
}

export function RegistrationDetailsInlineSpinner({
  label,
}: {
  label: string;
}) {
  return (
    <CardContent className="flex justify-center py-10">
      <Loader2
        className="h-8 w-8 animate-spin text-muted-foreground"
        aria-label={label}
      />
    </CardContent>
  );
}

/** Four placeholder cards matching the main registration-details queries. */
export function RegistrationDetailsSheetQuerySkeletons() {
  return (
    <div className="space-y-4 py-2">
      <Card className="gap-4">
        <CardHeader>
          <CardTitle className="font-semibold text-xl">Registration</CardTitle>
        </CardHeader>
        <RegistrationDetailsInlineSpinner label="Loading registration" />
      </Card>
      <Card className="gap-4">
        <CardHeader>
          <CardTitle className="font-semibold text-xl">Payments</CardTitle>
        </CardHeader>
        <RegistrationDetailsInlineSpinner label="Loading payments" />
      </Card>
      <Card className="gap-4">
        <CardHeader>
          <CardTitle className="font-semibold text-xl">
            Issues & Comments
          </CardTitle>
        </CardHeader>
        <RegistrationDetailsInlineSpinner label="Loading comments" />
      </Card>
      <Card className="gap-4">
        <CardHeader>
          <CardTitle className="font-semibold text-xl">
            Additional Information
          </CardTitle>
        </CardHeader>
        <RegistrationDetailsInlineSpinner label="Loading additional information" />
      </Card>
    </div>
  );
}
